import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';

import AbstractComponent from './AbstractComponent';

export default class Header extends AbstractComponent {
  /**
   * The HTML element of the close button in the mobile navigation.
   */
  private $closeMobileNavButton: HTMLButtonElement;

  /**
   * The HTML element of the hamburger button in the header.
   */
  private $hamburgerButton: HTMLButtonElement;

  /**
   * The HTML element of the mobile navigation.
   */
  private $mobileNav: HTMLElement;

  /**
   * The HTML element of the header.
   */
  private $header: HTMLElement;

  /**
   * Initializes the header component.
   */
  public initialize(): void {
    this.$closeMobileNavButton = document.querySelector('.mobile-nav__close');
    this.$hamburgerButton = document.querySelector('.header__hamburger');
    this.$mobileNav = document.querySelector('.mobile-nav');
    this.$header = document.querySelector('.header');

    this.onWindowScroll();

    // Add the event listeners.
    window.addEventListener('scroll', () => {
      this.onWindowScroll();
    });

    this.$closeMobileNavButton.addEventListener('click', (event) => {
      this.onCloseMobileNavButtonClicked(event);
    });

    this.$hamburgerButton.addEventListener('click', (event) => {
      this.onHamburgerButtonClicked(event);
    });
  }

  private onWindowScroll(): void {
    if (window.scrollY <= 0) {
      this.$header.classList.remove('has-scrolled');
    } else {
      this.$header.classList.add('has-scrolled');
    }
  }

  private onHamburgerButtonClicked(event: MouseEvent): void {
    event.preventDefault();

    disableBodyScroll(this.$mobileNav);

    this.$mobileNav.classList.add('is-open');
  }

  private onCloseMobileNavButtonClicked(event: MouseEvent): void {
    event.preventDefault();

    enableBodyScroll(this.$mobileNav);

    this.$mobileNav.classList.remove('is-open');
  }
}
